import { h } from "hyperapp";

import { Categories } from "../../common/categories/main";

export const controls = ({
  translations,
  actions: { fetchCategories, fetchPlaces, setCategory },
  section,
  state: {
    categories = [],
    categoryID,
    clientID,
    loadingPlaces,
    loadingCategories,
    pageNumber,
    pageSize,
    since,
  },
}): JSX.Element => {
  return (
    <form
      onsubmit={event => (
        event.preventDefault(),
        fetchPlaces({
          categoryID,
          clientID,
          pageNumber,
          pageSize,
          since,
        })
      )}
    >
      <div class="align-items-end justify-content-end form-row">
        {Categories({
          translations,
          actions: { setCategory, fetchCategories },
          section,
          state: {
            categories,
            categoryID,
            clientID,
            disabled: loadingPlaces,
            loading: loadingCategories,
          },
        })}
        <div class="col-sm-auto mb-3">
          <button
            class="btn btn-outline-primary form-control"
            disabled={loadingPlaces}
            type="submit"
          >
            {translations["search"]}
          </button>
        </div>
      </div>
    </form>
  );
};
